import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { UnifyApiInterface } from '@interface/unify-api/unify-api.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialUnifyApiState: BaseStoreInterface<UnifyApiInterface> = {
  ...BaseStoreStructure,
  data: {
    enums: {},
    events: {},
  },
};
